import { useTeam } from 'app/frontend/base/config/context/team'
import { useContext } from 'react'
import { LootContext } from '../context'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import Difficulty, {
  difficulties,
  difficultiesILVLDeficit,
} from 'app/frontend/types/custom/Difficulty'

type Props = {
  setToAll?: (value: boolean) => void
  setAsAll?: boolean
  className?: string
}

const DifficultySelector = ({ setToAll, setAsAll, className }: Props) => {
  const { team } = useTeam()

  const { difficulty, setDifficulty } = useContext(LootContext)

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {team.settings.wishlistDifficulties.value.length > 1 && (
        <>
          <span className='font-semibold'>Difficulty</span>
          <div>
            <Tabs
              value={setAsAll ? 'all' : difficulty}
              onValueChange={(value) => {
                if (value === 'all') {
                  setToAll?.(true)
                } else {
                  setToAll?.(false)
                  setDifficulty(value as Difficulty)
                }
              }}
            >
              <TabsList>
                {difficulties.map((diff, i) => {
                  if (team.settings.wishlistDifficulties.value.includes(diff)) {
                    return (
                      <TabsTrigger key={diff} value={diff}>
                        {Object.keys(difficultiesILVLDeficit)[i]}
                      </TabsTrigger>
                    )
                  }
                })}
                {setToAll && <TabsTrigger value={'all'}>All</TabsTrigger>}
              </TabsList>
            </Tabs>
          </div>
        </>
      )}
    </div>
  )
}

export default DifficultySelector
